export const OI_OVERVIEW_BAR_STRIKE_COUNT = '9'
/** Same preset as multistrike default (`nearAtmCount` / menu value 3 → ATM ±1, three strikes). */
export const OI_OVERVIEW_MS_NEAR_ATM = 3
/** Timeframe label shown on Overview multistrike tiles (matches the candle bucket fetched). */
export const OI_OVERVIEW_MS_TIMEFRAME_LABEL = '5m'
/** More than one session of 5m candles so the session filter always has a full day to keep. */
export const OI_OVERVIEW_CANDLE_BACK_COUNT = 90

/** Tile heights — the page scrolls, so charts get room to be legible instead of fitting the fold. */
export const OI_OVERVIEW_BAR_TILE_HEIGHT = 320
export const OI_OVERVIEW_LINE_TILE_HEIGHT = 280
